import {MonsterType} from "./CardTypes";

export function getMonsterAttackSound(monsterType: MonsterType): {
    sound: string,
    volume: number
} {
    if (monsterType === MonsterType.SIMPLE) {
        return {
            sound: 'sound_attack_simple',
            volume: 0.5
        }
    }
    else if (monsterType === MonsterType.BOSS) {
        return {
            sound: 'sound_attack_boss',
            volume: 0.6
        }
    }
    else {
        throw new Error(`Unknown monster type: ${monsterType}`)
    }
}